import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import St10020View from "../../Views/Stock/ST10020";
import Snackbar from "../../Components/Snackbar";

function ST10020(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [lanData, setLanData] = React.useState([]);
  const [inputs, setInputs] = React.useState({
    comboList: [],
    defaultComboList: [],
    comboValue: "",
    plantList: [],
  });
  const [paramsItemCd, setParamsItemCd] = React.useState("");
  const [rowData, setRowData] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const today = new Date();
  const monthAgo = new Date(today);
  let selectedPoNo = "";
  const [startDate, setStartDate] = React.useState(
    monthAgo.setMonth(today.getMonth() - 3)
  );
  const [endDate, setEndDate] = React.useState(new Date());
  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    SearchLogic();
  }, []);

  const SearchLogic = async () => {
    Dialog.ProgressBar(true);
    let getComboData = [];
    let getRowData = [];
    let whList = [];
    let checkWhList = [];
    let plList = [];
    let getLanData = [];
    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetWh,
        {
          whCd: "string",
        }
      ).then((result) => {
        let data = result.data;
        for (let i = 0; i < data.length; i++) {
          getComboData.push({
            value: data[i].value,
            name: data[i].name,
          });
        }
        inputs.comboList = getComboData;
      });
      for (let i = 0; i < inputs.comboList.length; i++) {}
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Stock.ST10020.GetStockList,
        {
          startDate: new Date(startDate),
          endDate: new Date(endDate),
          itemCd: !paramsItemCd ? "string" : paramsItemCd,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setRowData([]);
          setSnackbars({
            toggle: true,
            type: "info",
            message: getLanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else if (data.type === "데이터가 없습니다.") {
          setRowData([]);
          setSnackbars({
            toggle: true,
            type: "info",
            message: getLanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            for (let j = 0; j < inputs.plantList.length; j++) {
              if (data[i].plantCd === inputs.plantList[j].value) {
                plList.push(inputs.plantList[j].name);
              }
            }
            for (let j = 0; j < inputs.comboList.length; j++) {
              if (data[i].whCd === inputs.comboList[j].name) {
                whList.push(inputs.comboList[j].value);
              }
            }
            for (let j = 0; j < inputs.comboList.length; j++) {
              if (data[i].checkWhCd === inputs.comboList[j].value) {
                checkWhList.push(inputs.comboList[j].name);
              }
            }
            if (!checkWhList[i]) {
              checkWhList.push("");
            }
            if (!whList[i]) {
              whList.push("");
            }
            getRowData.push({
              plantCd: data[i].plantCd,
              plantNm: data[i].plantNm,
              stockTakingDt: data[i].stockTakingDt,
              // ? Commons.DateFormating(data[i].stockTakingDt.toString(), 2)
              // : "",
              soNo: data[i].soNo,
              itemCd: data[i].itemCd,
              itemNm: data[i].itemNm,
              itemStd: data[i].itemStd,
              lotNo: data[i].lotNo,
              whCd: whList[i],
              whNm: data[i].whCd,
              checkWhCd: data[i].whCd,
              closeYn: data[i].closeYn,
              stockQty: data[i].stockQty,
              stockAddQty: !data[i].itemFormula
                ? 0
                : Commons.splitReserveFun(
                    data[i].stockQty,
                    data[i].itemFormula
                  ),
              checkQty: data[i].stockQty,
              // needQty: data[i].checkQty - data[i].stockQty,
              itemUnit: data[i].itemUnit,
              itemStdAmt: data[i].itemStdAmt,
              soItemAmt:
                data[i].itemVatYn === "Y"
                  ? data[i].itemStdAmt * data[i].checkQty * 1.1
                  : data[i].itemStdAmt * data[i].checkQty,
              lCatego: data[i].lCatego,
              mCatego: data[i].mCatego,
              sCatego: data[i].sCatego,
              itemGroup: data[i].itemGroup,
              itemCatego: data[i].itemCatego,
              projectNm: data[i].projectNm,
              personCharg: data[i].personCharg,
            });
            setInputs({
              ...inputs,
              comboValue: data[i].whCd,
            });
          }
          setRowData(Commons.InsertNumber(getRowData));
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const SaveConfirm = (_type) => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        SaveLogic();
      }
    );
  };

  const SaveLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = null;
    let updateData = Commons.Deduplication(changedRowData);
    let getData = [];
    let salesOrders = [];
    // console.log(updateData[0].checkQty);
    try {
      if (!updateData[0]) {
        throw new Error("데이터를 선택해주세요");
      } else if (!updateData[0].checkWhCd) {
        throw new Error("실사창고를 입력해주세요");
      } else if (updateData[0].checkQty === null) {
        throw new Error("실사수량을 입력해주세요");
      }
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      for (let i = 0; i < updateData.length; i++) {
        getData.push({
          plantCd: updateData[i].plantCd,
          itemCd: updateData[i].itemCd,
          lotNo: updateData[i].lotNo,
          stocktakingDt:
            updateData[i].stockTakingDt == "" ||
            updateData[i].stockTakingDt == undefined ||
            updateData[i].stockTakingDt == null
              ? new Date(null)
              : Commons.DateStrChange(new Date(updateData[i].stockTakingDt)),
          stockQty: updateData[i].stockQty,
          checkQty: updateData[i].checkQty * 1,
          whCd: updateData[i].whCd,
          checkWhCd:
            updateData[i].checkWhCd.value == undefined
              ? updateData[i].whCd
              : updateData[i].checkWhCd.value,
          doYn: "N",
          // manufacDt: Commons.DateStrChange(new Date()),
          createId: userInfo.userId,
          createDate: Commons.DateStrChange(new Date()),
          updateId: userInfo.userId,
          updateDate: Commons.DateStrChange(new Date()),
        });
      }
      await Commons.Axios(
        "post1",
        Global.serverUrls.useUrl + Global.urls.logic.Stock.ST10020.CreateStock,
        getData
      ).then((result) => {
        let data = result.data;
        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            typ: "error",
            message: data,
          });
        } else {
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Save" && f.lanType === "SNACK"
            )[0].lanName,
          });
          SearchLogic();
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  return (
    <>
      <St10020View
        rowData={rowData}
        setRowData={setRowData}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        selectedRowData={selectedRowData}
        setSelectedRowData={setSelectedRowData}
        SearchLogic={SearchLogic}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        inputs={inputs}
        setInputs={setInputs}
        SaveConfirm={SaveConfirm}
        lanData={lanData}
        paramsItemCd={paramsItemCd}
        setParamsItemCd={setParamsItemCd}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default ST10020;
